export default __webpack_public_path__ + "static/media/newsletter.bd6edaef.png";